module.exports = __webpack_public_path__ + "static/img/banner21.c979d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainpage/banner21.jpg
// module id = Qufm
// module chunks = 18